import TwoWayMap from '../../map/two-way-map';

/**
 * Maps a filter-model field to the map that contains its possible values
 */
const FilterModelMap = new TwoWayMap(
  new Map<string, TwoWayMap<string, string>>([])
);

export default FilterModelMap;
